import * as React from "react";
import { BaseComponent } from "../../../../react-core/Html/BaseComponent";
import { PartLoading } from "../../../../react-core/Html/PartLoading";
import { Pager } from "../../../../react-core/Html/Pager";
import { JsonDateParser } from "../../../../react-core/Utils/JsonDateParser";
import { CommonHelper } from "../../../../react-core/Helpers/CommonHelper";
import { ContentTable, ProcessTypeOptions } from "../Resource/Content";
import { StatusOptions } from "../../Company/CompanyWizard/Resource/Content";
import { NetworkInstructionHistoryPaginatedModel } from "../../../../Wrap/Models/Models/Network/NetworkInstructionHistoryPaginatedModel";
import { NetworkInstructionHistoryModel } from "../../../../Wrap/Models/Models/Network/NetworkInstructionHistoryModel";
import { Urls } from "../../../Dashboard/Urls";
import { UserClient } from "../../../../Wrap/Api/User/User";
import { IndividualUserFunctionClient } from "../../../../Wrap/Api/User/IndividualUserFunction";
import { UserStore } from "../../../Dashboard/Stroes/Variable";

interface INetworkTableProps {
    tableData?: NetworkInstructionHistoryPaginatedModel;
    currentPage: number;
    pageSize: number;
    isLoading: boolean;
    handlePageChange: (currentPage) => void;
    handleSubmit?: (itemToDelete: number[]) => void;
    inprogress: boolean;
}

interface INetworkTableState {
    itemsToDelete: Array<number>;
    hasNetworkPermission: boolean;
}

export class NetworkTable extends BaseComponent<INetworkTableProps, INetworkTableState> {
    constructor(props: INetworkTableProps) {
        super(props);
        this.state = {
            itemsToDelete: [],
            hasNetworkPermission: false,
        };
    }

    componentDidMount() {
        const clientId = UserStore.getUserInfo().ClientId;

        if (clientId == null || clientId == 0) {
            const client = new UserClient();
            const promise = client.get();

            promise.onSuccess((result) => {
                this.checkNetworkPermission(result.ClientId);
            });
            promise.onError((err) => {});
        } else {
            this.checkNetworkPermission(clientId);
        }
    }

    public checkNetworkPermission(clientId: number) {
        const FunctionName = "CanModifyNetworks";
        const client = new IndividualUserFunctionClient();
        const promise = client.get(clientId, FunctionName);

        promise
            .onSuccess((data) => {
                this.setState({ hasNetworkPermission: data });
            })
            .onError(() => {
                this.setState({ hasNetworkPermission: false });
            });
    }

    public render(): JSX.Element {
        const { tableData, isLoading } = this.props;

        return (
            <>
                {isLoading ? this.renderPartLoading() : tableData && this.renderTable(tableData)}
                {tableData && tableData.TotalRows > 0 && this.renderPagination()}
            </>
        );
    }

    private renderPartLoading() {
        return (
            <PartLoading isLoading={true}>
                <div className="table-skeleton"></div>
            </PartLoading>
        );
    }

    private renderPagination() {
        const { currentPage, pageSize, handlePageChange } = this.props;
        const { TotalRows } = this.props.tableData;
        return (
            <div className="row">
                <div className="col-12 col-right">
                    <Pager
                        pager={{
                            CurrentPage: currentPage,
                            ResultsPerPage: pageSize,
                            TotalPages: TotalRows / pageSize,
                            TotalRecords: TotalRows,
                        }}
                        onChange={(recordsPerPage: number, pageIndex: number) => {
                            handlePageChange(pageIndex);
                        }}
                        recordsPerPageOptions={[10, 15, 20]}
                        isShowPerPageOptions={false}
                    />
                </div>
                {this.renderSubmitButton()}
            </div>
        );
    }

    private renderSubmitButton() {
        const { inprogress } = this.props;
        return (
            inprogress && (
                <div className="col-xs-6 right">
                    <button onClick={() => this.popupMessage()} id="btnSave" className="btn secondary">
                        {ContentTable.save}
                    </button>
                </div>
            )
        );
    }

    private popupMessage() {
        const { itemsToDelete } = this.state;
        if (itemsToDelete.length == 0) {window.alert(ContentTable.noWizardSelected);}
        else if (itemsToDelete.length > 0) {
            const confirm = window.confirm(ContentTable.confirmDelete);
            if (confirm) {this.handleSubmit();}
        }
    }

    private handleSubmit() {
        this.props.handleSubmit(this.state.itemsToDelete);
        this.setState({ itemsToDelete: [] });
    }

    private renderTableRow(data: NetworkInstructionHistoryModel): JSX.Element {
        return (
            <tr key={data.NetworkInstructionId}>
                <td>{JsonDateParser.getFormatDate(data.DateStarted, "dd/MM/yyyy")}</td>
                <td>{CommonHelper.getOptionsTxt(data.ProcessType, ProcessTypeOptions)}</td>
                <td>{CommonHelper.getOptionsTxt(data.Status, StatusOptions)}</td>
                <td>{data.NetworkName}</td>
                <td>{data.FcaReference}</td>
                <td>{data.CreateBy}</td>
                <td>{JsonDateParser.getFormatDate(data.LastUpdated, "dd/MM/yyyy")}</td>
                <td>{data.PostCode}</td>
                <td>{this.renderActionButton(data.NetworkInstructionId)}</td>
                {this.renderDeleteBox(data.NetworkInstructionId)}
                {/* {this.renderEditNotes()} */}
            </tr>
        );
    }

    private isChecked(id: number) {
        const { itemsToDelete } = this.state;
        if (!itemsToDelete || itemsToDelete.length === 0) {
            return false;
        }
        return itemsToDelete.indexOf(id) >= 0;
    }

    private renderEditNotes(id: number) {
        const editNotesUrl = Urls.get().NetworkDetailsWizard.getUrl() + "?id=" + id;
        return (
            <td className="text-right">
                <a href={editNotesUrl} className="hyperlink">
                    <span className="text">{ContentTable.editNotes}</span>
                </a>
            </td>
        );
    }

    private renderActionButton(id: number) {
        const { inprogress } = this.props;
        const url = Urls.get().NetworkDetailsWizard.getUrl() + "?id=" + id;
        return (
            <a href={url} className="btn secondary">
                <span className="text">
                    {inprogress && this.state.hasNetworkPermission ? ContentTable.resume : ContentTable.view}
                </span>
            </a>
        );
    }

    private renderDeleteBox(id: number) {
        const { inprogress } = this.props;
        return (
            inprogress &&
            this.state.hasNetworkPermission && (
                <td>
                    <input
                        id={id + ""}
                        name={ContentTable.delete}
                        checked={this.isChecked(id)}
                        onChange={(e: any) => {
                            this.handleDeleteChange(id);
                        }}
                        type="checkbox"
                        value="true"
                    />
                </td>
            )
        );
    }

    private handleDeleteChange(id: number) {
        let newItemsToDelete = this.state.itemsToDelete;
        if (this.isChecked(id)) {
            newItemsToDelete = newItemsToDelete.filter((o) => o != id);
        } else {
            newItemsToDelete.push(id);
        }
        this.setState({ itemsToDelete: newItemsToDelete });
    }

    private renderDeleteTHead() {
        const { inprogress } = this.props;
        return inprogress && <th>{ContentTable.delete}</th>;
    }

    private renderTable(tabledata: NetworkInstructionHistoryPaginatedModel): JSX.Element {
        const { inprogress } = this.props;
        const data = tabledata.Instructions;
        if (data.length === 0) {
            return <div id="noDataMsg">{ContentTable.noDataMsg}</div>;
        }

        return (
            <div>
                <table className="data-table">
                    <thead>
                        <tr>
                            {Object.values(ContentTable.header).map((ele) => {
                                return <th key={ele}>{ele}</th>;
                            })}
                            {this.renderDeleteTHead()}
                            {/* <th className="text-right">{ContentTable.editNotes}</th> */}
                        </tr>
                    </thead>
                    <tbody className="body-split">
                        <tr className="sub-head">
                            <td colSpan={inprogress ? 11 : 10}>{tabledata.TotalRows + " " + ContentTable.sessions}</td>
                        </tr>
                        {data.map((ele) => {
                            return this.renderTableRow(ele);
                        })}
                    </tbody>
                </table>
            </div>
        );
    }
}
